/**
 * @file index.tsx
 *
 * @fileoverview Renders a step list.
 */
import styles from "../wizard.module.scss";

interface WizardStepSimpleConnectorProps {}
export default function WizardStepSimpleConnector({}: WizardStepSimpleConnectorProps) {
  return (
    <div className={styles.wizardConnector}>
      <span />
    </div>
  );
}
export { WizardStepSimpleConnector };
